import { z } from "zod";
import type { infer as zInfer } from "zod";

export const INTERAC_EMAIL_VERIFICATION_STATUSES = {
  PENDING: "PENDING",
  MANUAL_REVIEW: "MANUAL_REVIEW",
  VERIFIED: "VERIFIED",
  FAILED: "FAILED",
} as const;

export const INTERAC_VERIFICATION_TYPES = {
  EMAIL: "EMAIL",
  PHONE: "PHONE",
} as const;

export const interacAddress = z.object({
  email: z.string(),
  mobile: z.string().nullish(),
  userExternalWalletId: z.string(),
  verificationStatus: z.enum(INTERAC_EMAIL_VERIFICATION_STATUSES),
  verificationType: z.enum(INTERAC_VERIFICATION_TYPES).nullish(),
  isDefaultWithdrawalWallet: z.boolean().nullish(),
});

export type InteracAddress = zInfer<typeof interacAddress>;
